import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import { submitLeadForm } from "../../utils/payment";

const statesAndUTs = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
  "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
  "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
  "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
  "Telangana", "Tripura", "Uttarakhand", "Uttar Pradesh", "West Bengal",
  "Andaman and Nicobar Islands", "Chandigarh",
  "Dadra and Nagar Haveli and Daman & Diu", "The Government of NCT of Delhi",
  "Jammu & Kashmir", "Ladakh", "Lakshadweep", "Puducherry",
];

const ConsultationOverlay = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: "", email: "", phone: "", message: "", state: "",
  });
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [onClose]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    submitLeadForm(formData, "consultation");
    setSubmitted(true);
    setTimeout(onClose, 2000);
  };

  const modal = (
    <div
      className="fixed inset-0 flex justify-center items-center bg-slate-900/60 backdrop-blur-sm p-4 z-[9999]"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="consultation-title"
    >
      <div
        className="bg-white relative w-full max-w-lg rounded-2xl p-6 sm:p-8 max-h-[90vh] overflow-y-auto shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full text-slate-500 hover:bg-slate-100 transition-colors"
        >
          ✕
        </button>
        {submitted ? (
          <div className="text-center py-10">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-green-100 flex items-center justify-center text-3xl text-green-600">✓</div>
            <h2 className="text-2xl font-bold text-slate-800">Thank You!</h2>
            <p className="mt-2 text-slate-500">We'll contact you within 24 hours.</p>
          </div>
        ) : (
          <>
            <h2 id="consultation-title" className="text-2xl font-bold text-brand-purple mb-1 pr-8">
              Free Consultation
            </h2>
            <p className="text-slate-500 mb-6 text-sm">
              Tell us about your study-abroad goals and we'll guide you.
            </p>
            <form onSubmit={handleSubmit} className="flex flex-col gap-3">
              <input type="text" className="w-full p-3 rounded-xl border border-slate-200 focus:border-brand-light focus:ring-2 focus:ring-brand-light/20 outline-none transition" name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} required />
              <input type="email" className="w-full p-3 rounded-xl border border-slate-200 focus:border-brand-light focus:ring-2 focus:ring-brand-light/20 outline-none transition" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
              <input type="tel" name="phone" className="w-full p-3 rounded-xl border border-slate-200 focus:border-brand-light focus:ring-2 focus:ring-brand-light/20 outline-none transition" placeholder="Phone" value={formData.phone} onChange={handleChange} required />
              <select name="state" className="w-full p-3 rounded-xl border border-slate-200 focus:border-brand-light focus:ring-2 focus:ring-brand-light/20 outline-none transition bg-white" value={formData.state} onChange={handleChange} required>
                <option value="">Select State/Union Territory</option>
                {statesAndUTs.map((state, index) => (
                  <option key={index} value={state}>{state}</option>
                ))}
              </select>
              <textarea name="message" placeholder="Tell us about your study-abroad plans" rows={3} className="w-full p-3 rounded-xl border border-slate-200 focus:border-brand-light focus:ring-2 focus:ring-brand-light/20 outline-none transition resize-none" value={formData.message} onChange={handleChange} />
              <div className="flex items-start gap-2 mt-1">
                <input type="checkbox" id="terms" name="terms" required className="mt-1" />
                <label htmlFor="terms" className="text-xs text-slate-500 leading-relaxed">
                  I agree to the <Link to="/terms" className="text-brand-light font-medium">Terms of Service</Link> and <Link to="/privacy" className="text-brand-light font-medium">Privacy Policy</Link>
                </label>
              </div>
              <button type="submit" className="btn-primary w-full mt-2">
                Book Free Consultation
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );

  return createPortal(modal, document.body);
};

export default ConsultationOverlay;
